import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DxLoadPanelModule } from 'devextreme-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SideNavInnerToolbarModule, SideNavOuterToolbarModule } from './layouts';
import { FooterModule } from './shared/components';
import { 
  AppInfoService, 
  AuthService, 
  LanguageService, 
  PivotGridConfigService, 
  ScreenService, 
  UserService 
} from './shared/services';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule, 
    AppRoutingModule,
    SideNavInnerToolbarModule, 
    SideNavOuterToolbarModule, 
    FooterModule,
    DxLoadPanelModule
  ],
  providers: [AppInfoService, AuthService, PivotGridConfigService, ScreenService, UserService],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private languageService: LanguageService) {
    languageService.initLanguage();
  }
}
